import { useQuery } from "@tanstack/react-query";
import {
	EventActivityFilters,
	EventActivityResponse,
	reportsService,
} from "../../services/reports.service";

const useEventActivityReport = (filters: EventActivityFilters) => {
	const enabled = Boolean(filters.accountId && filters.programId);

	return useQuery<EventActivityResponse>({
		queryKey: [
			"reports-event-activity",
			filters.accountId,
			filters.programId,
			filters.startDate ?? "",
			filters.endDate ?? "",
			filters.pageNumber ?? 0,
			filters.pageSize ?? 25,
		],
		queryFn: () => reportsService.getEventActivity(filters),
		enabled,
		staleTime: 1000 * 60 * 5,
	});
};

export default useEventActivityReport;
